import saga from "./saga";
import slice from "./slice";

const preference = {
  slice,
  saga,
};

export default preference;
